import { render, staticRenderFns } from "./c_picture_cube.vue?vue&type=template&id=42db63eb&scoped=true"
import script from "./c_picture_cube.vue?vue&type=script&lang=js"
export * from "./c_picture_cube.vue?vue&type=script&lang=js"
import style0 from "./c_picture_cube.vue?vue&type=style&index=0&id=42db63eb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42db63eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42db63eb')) {
      api.createRecord('42db63eb', component.options)
    } else {
      api.reload('42db63eb', component.options)
    }
    module.hot.accept("./c_picture_cube.vue?vue&type=template&id=42db63eb&scoped=true", function () {
      api.rerender('42db63eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_picture_cube.vue"
export default component.exports